import { Button } from 'antd'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import BudgetDriverModal from './components/BudgetDriverModal'
import BudgetDriversTable from './components/BudgetDriversTable'
import { useCtxBudgetDrivers } from '../../../../../features/budgetDrivers/queries/useCtxBudgetDrivers'
import { Loading } from '../../../../../components/Misc/Loading'
import RequestError from '../../../../../shared/components/RequestError'

const BudgetDrivers: React.FC = () => {
  const { t } = useTranslation()
  const { data: budgetDrivers = [], isLoading, isFetching, error, refetch } = useCtxBudgetDrivers()
  const [visible, setVisible] = useState(false)

  const handleCancel = () => {
    setVisible(false)
  }

  if (isLoading) return <Loading />

  if (error) return <RequestError error={error} refetch={refetch} />

  return (
    <>
      <p>{t('budgetDrivers:infoText')}</p>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '8px' }}>
        <Button type="primary" onClick={() => setVisible(true)}>{`+ ${t('global:add-new')}`}</Button>
      </div>
      <BudgetDriverModal budgetDriver={undefined} visible={visible} handleCancel={handleCancel} />
      <BudgetDriversTable budgetDrivers={budgetDrivers} isFetching={isFetching} />
    </>
  )
}

export default BudgetDrivers
